class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.addEventListener('focusin',(event) =>{
      this.open();
    });
    this.addEventListener('focusout',this.debounce((event) =>{
      this.close();
    },300));
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    console.log(searchTerm);
    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,vendor,product_type,tag,variants.sku,variants.barcode,variants.title&section_id=predictive-search`)
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          var error = new Error(response.status);
          console.log('1');
          this.close();
          throw error;
          
        }
        
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        console.log('2');
        this.close();
        throw error;
      });
  }
  
  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  } 
}

customElements.define('predictive-search', PredictiveSearch);
